const getThemeValue = () => {
  if (typeof window === 'undefined') return 'auto';
  try {
    const theme = localStorage.getItem('rfs:theme');
    if (!['auto', 'light', 'dark', 'black'].includes(theme)) throw new Error();
    return theme;
  } catch (e) {
    localStorage.setItem('rfs:theme', 'auto');
    return 'auto';
  }
};

const getLanguageValue = () => {
  if (typeof window === 'undefined') return 'en';
  try {
    const acceptedLangs = ['ca', 'en', 'es', 'fr', 'pl', 'zh-cn', 'zh-tw'];
    const params = new URLSearchParams(window.location.search);
    const hl = params.get('hl')?.toLowerCase();
    if (acceptedLangs.includes(hl)) {
      localStorage.setItem('rfs:language', hl);
      return hl;
    }
    const lang = localStorage.getItem('rfs:language');
    if (!acceptedLangs.includes(lang)) throw new Error();
    return lang;
  } catch (e) {
    localStorage.setItem('rfs:language', 'en');
    return 'en';
  }
};

export default {
  theme: getThemeValue(),
  language: getLanguageValue(),
};
